// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ⚠️ Storage bucket should be the bucket name (usually *.appspot.com)
const firebaseConfig = {
  apiKey: "AIzaSyAyiuqqZWz9QEQAuOIj9AsL4rRcPebZfdw",
  authDomain: "learnsmart-c2a7e.firebaseapp.com",
  projectId: "learnsmart-c2a7e",
  storageBucket: "photos-oysi5", // ← fixed
  messagingSenderId: "735353248164",
  appId: "1:735353248164:web:39dd665341734b3ef80931",
  measurementId: "G-RR4P2F6MY0",
};

const app = initializeApp(firebaseConfig);

// Optional: uncomment to see Firestore transport fallbacks in the console
// setLogLevel("debug");

/**
 * Firestore:
 * - experimentalAutoDetectLongPolling: prefers normal streaming, but falls back when networks block it
 * - useFetchStreams: false → avoids fetch streaming (often broken by proxies/antivirus)
 * - persistentLocalCache: offline cache + multi-tab coherence
 */
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
  ignoreUndefinedProperties: true,
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export const auth = getAuth(app);
export const storage = getStorage(app, "gs://photos-oysi5");